// extracted by mini-css-extract-plugin
export default {"SaveButton":"save-button_SaveButton__eR2n+"};